// extracted by mini-css-extract-plugin
module.exports = {"articleHeroImage":"ArticleHeroImageRight_articleHeroImage__jV9gY","body-large":"ArticleHeroImageRight_body-large__EgeNf"};